import React from "react";
import { get, toNumber } from "../../components/Common";
import { useSelector, useDispatch } from "react-redux";
import { AreaTextField } from "../DesignerCommon";
import AreaSelectField from "../../components/AreaSelectField";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import FrameAppBar from "../main_drawer/FrameAppBar";
import Grid from "@material-ui/core/Grid";
import * as APP from "../../redux_store/appState";
import * as BSL_Common from "../../components/BSL_CommonControls";
import { BSL_DialogData } from "../../components/BSL_Dialog";

// Redux Actions
import { BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";
import { updateAreaSpecification, updateAreaSpecificationValidateJob } from "../../redux_store/jobState";

const useStyles = makeStyles({
    root: {
        background: "#090909ad",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        textAlign: "center",
        paddingTop: "85px",
    },
    grow: {
        flexGrow: 1,
    },
    closeButton: {
        float: "right",
        marginTop: "0px",
        marginRight: "-20px",
        color: "white",
    },
    rowInputCell: {
        padding: "20px",
    },
});

export default (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const job = useSelector((state) => state.job);
    const area_design_specs = job?.AreaSpecifications?.[areaIndex];
    const RoofSheetParameters = area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING];

    const [dialogData, setDialogData] = React.useState(null);

    const { areaIndex } = props;
    const area_length =
        get(job, "AreaSpecifications." + areaIndex + "." + BASIC_SPECS_SECTIONS.SHAPE + ".Length") + 150; // added buffer to allow for partial attachments, short term fix KC 23/02/2022
    const area_depth = get(job, "AreaSpecifications." + areaIndex + "." + BASIC_SPECS_SECTIONS.SHAPE + ".Depth") + 150; // added buffer to allow for partial attachments, short term fix KC 23/02/2022
    const area_design_specs_shape_cutouts = get(
        job,
        "AreaSpecifications." + areaIndex + "." + BASIC_SPECS_SECTIONS.SHAPE + ".CUTOUTS"
    );
    let maxSheetOverhang = RoofSheetParameters?.RoofSheetData?.max_overhang;
    if (maxSheetOverhang === undefined) maxSheetOverhang = 200;

    let backLeftEnabled = area_design_specs_shape_cutouts["BackLeft-CutoutType"] !== "None";
    let backMidEnabled = area_design_specs_shape_cutouts["BackMid-CutoutType"] !== "None";
    let backRightEnabled = area_design_specs_shape_cutouts["BackRight-CutoutType"] !== "None";
    let frontLeftEnabled = area_design_specs_shape_cutouts["FrontLeft-CutoutType"] !== "None";
    let frontRightEnabled = area_design_specs_shape_cutouts["FrontRight-CutoutType"] !== "None";

    const showCustomCutoutDialog = () => {
        setDialogData({
            // error: true,
            style: { width: "80%" },
            title: "How to define a custom cutout :",
            message: [
                <div>
                    <img style={{ width: "100%" }} src={"/app/images/info_customcutouts.png"} />
                    <br />
                    1. Select a number of line segments that you need in the cutout. This will create points that
                    defined the segments. Eg; 3 segments need 2 points.
                    <br />
                    2. Define the X and Y offset for each point at the end of each segment. Segments are defined from
                    LEFT to RIGHT.
                    <br />
                    eg; P1 is to the right of the start of the cutout... X is the distance RIGHT from the start point
                    (or left if negative), Y is the distance UP (positive) or DOWN (negative).
                    <br />
                    3. Points after the first one are RELATIVE to the last point.
                    <br />
                    <span style={{ color: "red" }}>
                        Note: While flexibility is left in the system to potentially cater for unusual needs, shapes
                        that cross back over themselves or fall outside of the original rectangle envelope of the
                        structure may cause serious problems, are not officially supported, and may need supplementary
                        engineering.
                    </span>
                </div>,
            ],
            onClose: () => setDialogData(null),
        });
    };

    const updateCutoutPoint = (dataField, X, Y) => {
        let error = dispatch(
            updateAreaSpecificationValidateJob(
                areaIndex,
                BASIC_SPECS_SECTIONS.SHAPE,
                "CUTOUTS." + dataField,
                "(" + X + "," + Y + ")"
            )
        );
        if (error && error.error) {
            dispatch(APP.showDialogData(error));
        }
        return;
    };

    const getPointInputs = (cutout_type, number, enabled) => {
        let items = [];
        for (var i = 1; i < number; i++) {
            let points = area_design_specs_shape_cutouts[cutout_type + "-" + i + "-CustomPoint"]
                ? {
                      X: toNumber(
                          area_design_specs_shape_cutouts[cutout_type + "-" + i + "-CustomPoint"].split(",")[0]
                      ),
                      Y: toNumber(
                          area_design_specs_shape_cutouts[cutout_type + "-" + i + "-CustomPoint"].split(",")[1]
                      ),
                  }
                : { X: 0, Y: 0 };

            let section = cutout_type + "-" + i + "-CustomPoint";

            items.push(
                <BSL_Common.SectionRow>
                    <AreaTextField
                        disabled={!enabled}
                        root_style={{ width: "80px", flex: 1 }}
                        label={"Point " + i}
                        allowZero={true}
                        min={-500}
                        max={toNumber(area_design_specs_shape_cutouts[cutout_type + "-WidthX"])}
                        value={points.X}
                        startAdornment={<span style={{ color: "rgb(180, 189, 255)", fontWeight: "400" }}>X: </span>}
                        blurOnEnter={true}
                        onBlur={(value) => {
                            updateCutoutPoint(section, value, points.Y);
                        }}
                    />
                    <AreaTextField
                        disabled={!enabled}
                        root_style={{ width: "120px", flex: 1 }}
                        label={i == 1 ? " " : "from " + "P" + (i - 1)}
                        allowZero={true}
                        min={-toNumber(area_design_specs_shape_cutouts[cutout_type + "-WidthY"])}
                        max={toNumber(area_design_specs_shape_cutouts[cutout_type + "-WidthY"])}
                        value={points.Y}
                        startAdornment={<span style={{ color: "rgb(180, 189, 255)", fontWeight: "400" }}>Y: </span>}
                        blurOnEnter={true}
                        onBlur={(value) => {
                            updateCutoutPoint(section, points.X, value);
                        }}
                    />
                </BSL_Common.SectionRow>
            );
        }

        return items;
    };

    return (
        <Paper elevation={20} className={classes.root}>
            <FrameAppBar title={"Edit Cutouts for Area " + (props.areaIndex + 1)} onClick={props.onClose} />
            <div style={{ overflowX: "hidden", overflowY: "auto", width: "550px", padding: "8px" }}>
                <Grid container spacing={0}>
                    <Grid className={classes.rowInputCell} item xs={4}>
                        <AreaSelectField
                            label={"Back Left Cutout"}
                            value={area_design_specs_shape_cutouts["BackLeft-CutoutType"]}
                            items={["None", "Angle", "Step", { Key: "CornerBay", Display: "Corner Bay" }, "Custom"]}
                            valueKey="Key"
                            displayKey="Display"
                            areaIndex={areaIndex}
                            section={BASIC_SPECS_SECTIONS.SHAPE}
                            dataField="BackLeft-CutoutType"
                            onChange={(e) => {
                                let new_cutouts = { ...area_design_specs_shape_cutouts };
                                if (e.target.value !== "None") {
                                    if (area_design_specs?.META?.IsFreestanding) new_cutouts["BackLeft-Attachment"] = 0;
                                }
                                new_cutouts["BackLeft-CutoutType"] = e.target.value;

                                dispatch(
                                    updateAreaSpecificationValidateJob(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS",
                                        new_cutouts
                                    )
                                );
                                if (e.target.value === "Custom") {
                                    showCustomCutoutDialog();
                                }
                            }}
                        />
                        <AreaTextField
                            disabled={!backLeftEnabled}
                            root_style={{ width: "200px" }}
                            label="Length <->"
                            min={100}
                            max={
                                area_length -
                                (backRightEnabled ? area_design_specs_shape_cutouts["BackRight-WidthX"] : 0)
                            }
                            value={area_design_specs_shape_cutouts["BackLeft-WidthX"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackLeft-WidthX",
                                        value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!backLeftEnabled}
                            root_style={{ width: "200px" }}
                            label="Depth v"
                            min={100}
                            max={
                                area_depth -
                                (frontLeftEnabled ? area_design_specs_shape_cutouts["FrontLeft-WidthY"] : 0)
                            }
                            value={area_design_specs_shape_cutouts["BackLeft-WidthY"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackLeft-WidthY",
                                        value
                                    )
                                );
                            }}
                        />

                        <AreaTextField
                            disabled={!backLeftEnabled}
                            root_style={{ width: "200px" }}
                            label="Corner"
                            allowZero={true}
                            min={30}
                            max={Math.max(
                                area_design_specs_shape_cutouts["BackLeft-WidthY"],
                                area_design_specs_shape_cutouts["BackLeft-WidthX"]
                            )}
                            value={area_design_specs_shape_cutouts["BackLeft-WidthD"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackLeft-WidthD",
                                        value
                                    )
                                );
                            }}
                        />

                        <AreaTextField
                            disabled={!backLeftEnabled}
                            root_style={{ width: "200px" }}
                            label="Overhang"
                            allowZero={true}
                            min={30}
                            max={maxSheetOverhang}
                            value={area_design_specs_shape_cutouts["BackLeft-Overhang"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackLeft-Overhang",
                                        value
                                    )
                                );
                            }}
                        />
                        {area_design_specs_shape_cutouts["BackLeft-CutoutType"] === "Custom" && (
                            <>
                                <AreaSelectField
                                    label="Num Segments"
                                    value={area_design_specs_shape_cutouts["BackLeft-CustomNumSegments"]}
                                    items={[2, 3, 4, 5, 6]}
                                    onChange={(e) => {
                                        dispatch(
                                            updateAreaSpecificationValidateJob(
                                                areaIndex,
                                                BASIC_SPECS_SECTIONS.SHAPE,
                                                "CUTOUTS.BackLeft-CustomNumSegments",
                                                e.target.value
                                            )
                                        );
                                    }}
                                />
                                {getPointInputs(
                                    "BackLeft",
                                    toNumber(area_design_specs_shape_cutouts["BackLeft-CustomNumSegments"]),
                                    backLeftEnabled
                                )}
                            </>
                        )}
                    </Grid>
                    <Grid className={classes.rowInputCell} item xs={4}>
                        <AreaSelectField
                            label={"Back Mid Cutout"}
                            value={area_design_specs_shape_cutouts["BackMid-CutoutType"]}
                            items={["None", "Box", "Bay"]}
                            valueKey="Key"
                            displayKey="Display"
                            areaIndex={areaIndex}
                            section={BASIC_SPECS_SECTIONS.SHAPE}
                            dataField="BackMid-CutoutType"
                            onChange={(e) => {
                                dispatch(
                                    updateAreaSpecificationValidateJob(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackMid-CutoutType",
                                        e.target.value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!backMidEnabled}
                            root_style={{ width: "200px" }}
                            label="Length <->"
                            min={100}
                            max={
                                area_length -
                                (backRightEnabled ? area_design_specs_shape_cutouts["BackRight-WidthX"] : 0)
                            }
                            value={area_design_specs_shape_cutouts["BackMid-WidthX"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecificationValidateJob(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackMid-WidthX",
                                        value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!backMidEnabled}
                            root_style={{ width: "200px" }}
                            label="Depth v"
                            min={100}
                            max={area_depth - 100}
                            value={area_design_specs_shape_cutouts["BackMid-WidthY"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecificationValidateJob(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackMid-WidthY",
                                        value
                                    )
                                );
                            }}
                        />

                        <AreaTextField
                            disabled={
                                !backMidEnabled || area_design_specs_shape_cutouts["BackMid-CutoutType"] === "Box"
                            }
                            root_style={{ width: "200px" }}
                            label="Corner"
                            allowZero={true}
                            min={30}
                            max={Math.max(
                                area_design_specs_shape_cutouts["BackMid-WidthY"],
                                area_design_specs_shape_cutouts["BackMid-WidthX"]
                            )}
                            value={area_design_specs_shape_cutouts["BackMid-WidthD"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecificationValidateJob(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackMid-WidthD",
                                        value
                                    )
                                );
                            }}
                        />

                        <AreaTextField
                            disabled={!backMidEnabled}
                            root_style={{ width: "200px" }}
                            label="Offset"
                            min={area_design_specs_shape_cutouts["BackLeft-WidthX"]}
                            max={
                                area_length -
                                (backLeftEnabled ? area_design_specs_shape_cutouts["BackLeft-WidthX"] : 0) -
                                (backRightEnabled ? area_design_specs_shape_cutouts["BackRight-WidthX"] : 0) -
                                area_design_specs_shape_cutouts["BackMid-WidthX"]
                            }
                            value={area_design_specs_shape_cutouts["BackMid-Offset"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecificationValidateJob(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackMid-Offset",
                                        value
                                    )
                                );
                            }}
                        />

                        <AreaTextField
                            disabled={!backMidEnabled}
                            root_style={{ width: "200px" }}
                            label="Overhang"
                            allowZero={true}
                            min={30}
                            max={maxSheetOverhang}
                            value={area_design_specs_shape_cutouts["BackMid-Overhang"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackMid-Overhang",
                                        value
                                    )
                                );
                            }}
                        />
                    </Grid>
                    <Grid className={classes.rowInputCell} item xs={4}>
                        <AreaSelectField
                            label={"Back Right Cutout"}
                            value={area_design_specs_shape_cutouts["BackRight-CutoutType"]}
                            items={["None", "Angle", "Step", { Key: "CornerBay", Display: "Corner Bay" }, "Custom"]}
                            valueKey="Key"
                            displayKey="Display"
                            areaIndex={areaIndex}
                            section={BASIC_SPECS_SECTIONS.SHAPE}
                            dataField="BackRight-CutoutType"
                            onChange={(e) => {
                                dispatch(
                                    updateAreaSpecificationValidateJob(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackRight-CutoutType",
                                        e.target.value
                                    )
                                );
                                if (e.target.value === "Custom") {
                                    showCustomCutoutDialog();
                                }
                            }}
                        />
                        <AreaTextField
                            disabled={!backRightEnabled}
                            root_style={{ width: "200px" }}
                            label="Length <->"
                            min={100}
                            max={
                                area_length - (backLeftEnabled ? area_design_specs_shape_cutouts["BackLeft-WidthX"] : 0)
                            }
                            value={area_design_specs_shape_cutouts["BackRight-WidthX"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackRight-WidthX",
                                        value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!backRightEnabled}
                            root_style={{ width: "200px" }}
                            label="Depth v"
                            min={100}
                            max={
                                area_depth -
                                (frontRightEnabled ? area_design_specs_shape_cutouts["FrontRight-WidthY"] : 0)
                            }
                            value={area_design_specs_shape_cutouts["BackRight-WidthY"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackRight-WidthY",
                                        value
                                    )
                                );
                            }}
                        />

                        <AreaTextField
                            disabled={!backRightEnabled}
                            root_style={{ width: "200px" }}
                            label="Corner"
                            allowZero={true}
                            min={30}
                            max={Math.max(
                                area_design_specs_shape_cutouts["BackRight-WidthY"],
                                area_design_specs_shape_cutouts["BackRight-WidthX"]
                            )}
                            value={area_design_specs_shape_cutouts["BackRight-WidthD"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackRight-WidthD",
                                        value
                                    )
                                );
                            }}
                        />

                        <AreaTextField
                            disabled={!backRightEnabled}
                            root_style={{ width: "200px" }}
                            label="Overhang"
                            allowZero={true}
                            min={30}
                            max={maxSheetOverhang}
                            value={area_design_specs_shape_cutouts["BackRight-Overhang"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.BackRight-Overhang",
                                        value
                                    )
                                );
                            }}
                        />

                        {area_design_specs_shape_cutouts["BackRight-CutoutType"] === "Custom" && (
                            <>
                                <AreaSelectField
                                    label="Num Segments"
                                    value={area_design_specs_shape_cutouts["BackRight-CustomNumSegments"]}
                                    items={[2, 3, 4, 5, 6]}
                                    onChange={(e) => {
                                        dispatch(
                                            updateAreaSpecificationValidateJob(
                                                areaIndex,
                                                BASIC_SPECS_SECTIONS.SHAPE,
                                                "CUTOUTS.BackRight-CustomNumSegments",
                                                e.target.value
                                            )
                                        );
                                    }}
                                />
                                {getPointInputs(
                                    "BackRight",
                                    toNumber(area_design_specs_shape_cutouts["BackRight-CustomNumSegments"]),
                                    backRightEnabled
                                )}
                            </>
                        )}
                    </Grid>
                    <Grid className={classes.rowInputCell} item xs={4}>
                        <AreaSelectField
                            label={"Front Left Cutout"}
                            value={area_design_specs_shape_cutouts["FrontLeft-CutoutType"]}
                            items={["None", "Angle", "Step", "Custom"]}
                            valueKey="Key"
                            displayKey="Display"
                            areaIndex={areaIndex}
                            section={BASIC_SPECS_SECTIONS.SHAPE}
                            dataField="FrontLeft-CutoutType"
                            onChange={(e) => {
                                dispatch(
                                    updateAreaSpecificationValidateJob(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.FrontLeft-CutoutType",
                                        e.target.value
                                    )
                                );
                                if (e.target.value === "Custom") {
                                    showCustomCutoutDialog();
                                }
                            }}
                        />
                        <AreaTextField
                            disabled={!frontLeftEnabled}
                            root_style={{ width: "200px" }}
                            label="Length <->"
                            min={100}
                            max={
                                area_length -
                                (frontRightEnabled ? area_design_specs_shape_cutouts["FrontRight-WidthX"] : 0)
                            }
                            value={area_design_specs_shape_cutouts["FrontLeft-WidthX"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.FrontLeft-WidthX",
                                        value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!frontLeftEnabled}
                            root_style={{ width: "200px" }}
                            label="Depth ^"
                            min={100}
                            max={
                                area_depth - (backLeftEnabled ? area_design_specs_shape_cutouts["BackLeft-WidthY"] : 0)
                            }
                            value={area_design_specs_shape_cutouts["FrontLeft-WidthY"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.FrontLeft-WidthY",
                                        value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!frontLeftEnabled}
                            root_style={{ width: "200px" }}
                            label="Overhang"
                            allowZero={true}
                            min={30}
                            max={maxSheetOverhang}
                            value={area_design_specs_shape_cutouts["FrontLeft-Overhang"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.FrontLeft-Overhang",
                                        value
                                    )
                                );
                            }}
                        />
                        {area_design_specs_shape_cutouts["FrontLeft-CutoutType"] === "Custom" && (
                            <>
                                <AreaSelectField
                                    label="Num Segments"
                                    value={area_design_specs_shape_cutouts["FrontLeft-CustomNumSegments"]}
                                    items={[2, 3, 4, 5, 6]}
                                    onChange={(e) => {
                                        dispatch(
                                            updateAreaSpecificationValidateJob(
                                                areaIndex,
                                                BASIC_SPECS_SECTIONS.SHAPE,
                                                "CUTOUTS.FrontLeft-CustomNumSegments",
                                                e.target.value
                                            )
                                        );
                                    }}
                                />
                                {getPointInputs(
                                    "FrontLeft",
                                    toNumber(area_design_specs_shape_cutouts["FrontLeft-CustomNumSegments"]),
                                    frontLeftEnabled
                                )}
                            </>
                        )}
                    </Grid>
                    <Grid className={classes.rowInputCell} item xs={4}></Grid>
                    <Grid className={classes.rowInputCell} item xs={4}>
                        <AreaSelectField
                            label={"Front Right Cutout"}
                            value={area_design_specs_shape_cutouts["FrontRight-CutoutType"]}
                            items={["None", "Angle", "Step", "Custom"]}
                            valueKey="Key"
                            displayKey="Display"
                            areaIndex={areaIndex}
                            section={BASIC_SPECS_SECTIONS.SHAPE}
                            dataField="FrontRight-CutoutType"
                            onChange={(e) => {
                                dispatch(
                                    updateAreaSpecificationValidateJob(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.FrontRight-CutoutType",
                                        e.target.value
                                    )
                                );
                                if (e.target.value === "Custom") {
                                    showCustomCutoutDialog();
                                }
                            }}
                        />
                        <AreaTextField
                            disabled={!frontRightEnabled}
                            root_style={{ width: "200px" }}
                            label="Length <->"
                            min={100}
                            max={
                                area_length -
                                (frontLeftEnabled ? area_design_specs_shape_cutouts["FrontLeft-WidthX"] : 0)
                            }
                            value={area_design_specs_shape_cutouts["FrontRight-WidthX"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.FrontRight-WidthX",
                                        value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!frontRightEnabled}
                            root_style={{ width: "200px" }}
                            label="Depth ^"
                            min={100}
                            max={area_depth}
                            value={area_design_specs_shape_cutouts["FrontRight-WidthY"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.FrontRight-WidthY",
                                        value
                                    )
                                );
                            }}
                        />
                        <AreaTextField
                            disabled={!frontRightEnabled}
                            root_style={{ width: "200px" }}
                            label="Overhang"
                            allowZero={true}
                            min={30}
                            max={maxSheetOverhang}
                            value={area_design_specs_shape_cutouts["FrontRight-Overhang"]}
                            adornmentText="mm"
                            blurOnEnter={true}
                            onBlur={(value) => {
                                dispatch(
                                    updateAreaSpecification(
                                        areaIndex,
                                        BASIC_SPECS_SECTIONS.SHAPE,
                                        "CUTOUTS.FrontRight-Overhang",
                                        value
                                    )
                                );
                            }}
                        />
                        {area_design_specs_shape_cutouts["FrontRight-CutoutType"] === "Custom" && (
                            <>
                                <AreaSelectField
                                    label="Num Segments"
                                    value={area_design_specs_shape_cutouts["FrontRight-CustomNumSegments"]}
                                    items={[2, 3, 4, 5, 6]}
                                    onChange={(e) => {
                                        dispatch(
                                            updateAreaSpecificationValidateJob(
                                                areaIndex,
                                                BASIC_SPECS_SECTIONS.SHAPE,
                                                "CUTOUTS.FrontRight-CustomNumSegments",
                                                e.target.value
                                            )
                                        );
                                    }}
                                />

                                {getPointInputs(
                                    "FrontRight",
                                    toNumber(area_design_specs_shape_cutouts["FrontRight-CustomNumSegments"]),
                                    frontRightEnabled
                                )}
                            </>
                        )}
                    </Grid>
                </Grid>
            </div>
            <div style={{ width: "4px", background: "#CCC", cursor: "e-resize" }}></div>
            <BSL_DialogData dialogData={dialogData} maxWidth="md" fullWidth dispatch={dispatch} />
        </Paper>
    );
};
